<fieldset>
  <div class="column-100">
      <gmt-input label="Datum žádosti o mezitimní rozhodnutí" required="true">
        <input type="text" pick-a-date [(ngModel)]="data.expropriationInterimDecisionRequestDate" [maxToday]="true"/>
      </gmt-input>
  </div>
</fieldset>
